import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DiscountModal from "../../common/discountModel";
import QRScanImage from "../../assets/img/icons/qr_scan_Icon.png";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReactToPrint from "react-to-print";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { getUserDetailByNumber, UpdateBillCounterSell } from "./updateBillApi";
import { useDispatch, useSelector } from "react-redux";
import { routePath } from "../../constants/routePath";
import MenuSideBar from "./menuSideBar";
import Swal from "sweetalert2";
import PrintBilling from "../../common/printBilling";
import { addBillPart, updateBil, updateBillPart } from "./updateBillApiHandler";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { updateBillValidation } from "./updateBillValidationFunctions";
import { TotalAmount, validationUpdate } from "./updateBillingFunctions";
import Pop from "./pop";
import { isArray } from "lodash";
import PrintBillingPdf from "../../common/printBillingPdf";
import { removetableOrder } from "../counterSellBilling/fireBaseFunctions";
import { handleSendFile } from "../../common/printBillingApi";
import CustomerModal from "../../common/customerModal";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { setbillerMenuseletected } from "../../app/store/reducer";
import ItemSidebar from "./itemSidebar";
import CloseIcon from "../../assets/img/icons/close_icon.png";
import PartPaymentModal from "./PartPaymentModal";
import {
  addBillPartPayment,
  updateBillPartPayment,
} from "../counterSellBilling/counterSellBillingApi";
import { getBillCounterSellPartPayment } from "../counterSell/counterSellApi";

export default function UpdateBills() {
  const [CustomerFlag, setCustomerFlag] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];
  const dispatch = useDispatch();
  const [searchItemValue, setSeachItemValue] = useState("");
  const [payloadcollection, setPayloadCollection] = useState([]);
  const [paymentMode, setPaymentMode] = useState("Cash");
  const [indexTableItem, setIndexTableItem] = useState();
  const navigate = useNavigate();
  const [currentDataArr, setCurrentDataArr] = useState(null);
  // const
  const [billData, setbillData] = useState({ counterSalesChild: [] });
  const updateBillData = useSelector((state) => state.reducer.updateBillData);
  const tableName = useSelector((state) => state.reducer.tableName);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [partModal, setPartModal] = React.useState(false);

  const componentRefPDF = useRef();

  const handleClose3 = () => setOpen3(false);
  const handleClose2 = () => setOpen2(false);
  const handleClosepart = () => setPartModal(false);

  const componentRef = useRef();
  const [NextBtnDisplay, setNextBtnDisplay] = useState(false);
  const [eventHandle, setEventHandle] = useState({
    add: false,
    billNumber: null,
    componentRef: null,
  });
  const [displayContinue, setDisplayContinue] = useState(false);
  const removeFromPayloadCollection = (item) => {
    let temp = [...billData.counterSalesChild];
    temp = temp.filter((elet) => {
      return elet?.itemId != item?.itemId;
    });
    // console.log("removefrompayload ", temp);
    setPayloadCollection([...temp]);
  };
  const removeItem = (index) => {
    let arr = [...(billData.counterSalesChild ?? [])];
    arr.splice(index, 1);
    setbillData({
      ...billData,
      counterSalesChild: arr,
    });
  };
  const [displayPayloadcollection, setDisplayPayloadcollection] = useState([]);

  useEffect(() => {
    let arr = [...(billData.counterSalesChild ?? [])];
    arr = arr.map((item, index) => {
      return item;
    });
    let obj = {};
    arr.forEach((ele, index) => {
      // console.log("ele doc", ele);
      if (obj[ele.employeeMasterId + "_" + ele.itemId]) {
        obj[ele.employeeMasterId + "_" + ele.itemId] = {
          ...obj[ele.employeeMasterId + "_" + ele.itemId],
          employeePayPercentage:
            parseFloat(
              obj[ele.employeeMasterId + "_" + ele.itemId][
                "employeePayPercentage"
              ],
            ) + parseFloat(ele.employeePayPercentage),
        };
      } else {
        obj[ele.employeeMasterId + "_" + ele.itemId] = { ...ele };
      }
    });
    let arrnew = [
      ...Object.keys(obj).map((key, index) => {
        return obj[key];
      }),
    ];
    setDisplayPayloadcollection([...arrnew]);
  }, [billData.counterSalesChild]);
  const navigateCallback = () => {
    if (Object.keys(updateBillData).length === 0) {
      navigate(routePath.COUNTERSELL);
    }
  };
  // useEffect(())

  useEffect(() => {
    // console.log("payloadcollectionpayloadcollection ", payloadcollection);
  }, [payloadcollection]);
  useEffect(() => {
    navigateCallback();
    console.log("Update Bill Data ", updateBillData);
    // let cp = [...updateBillData?.counterSalesChild];
    let cp = [...(updateBillData?.counterSalesChild ?? [])];
    let arr = [...(updateBillData?.counterSalesChild ?? [])].filter(
      (item, index, self) =>
        index === self.findIndex((obj) => obj.itemId === item.itemId),
    );
    let obj = { ...updateBillData };
    obj.counterSalesChild = arr;

    setPayloadCollection(cp);
    setbillData(obj);
  }, []);

  useEffect(() => {
    if (paymentMode === "Part Payment") {
      const payload = {
        date: payloadDateFormat(),
        status: "",
        filter: "",
        search: "",
        page: 1,
        pageSize: 10,
      };

      getBillCounterSellPartPayment(payload, (res) => {
        const data = res?.data?.data?.counterSalesHeader;
        if (Array.isArray(data)) {
          const matchedBill = data.find(
            (item) => Number(item.id) === Number(billData.id),
          );
          // console.log(";;", matchedBill);

          if (matchedBill) {
            setbillData((prev) => ({
              ...prev,
              ...matchedBill, // ✅ merge instead of replace
            }));
          }
        }
      });
    }
  }, [paymentMode]);
  console.log("ggg", billData);
  const previousBillDataRef = useRef(billData?.counterSalesChild);

  useEffect(() => {
    // console.log("update payloadcollection ", payloadcollection);
  }, [payloadcollection]);
  useEffect(() => {
    //   console.log("Update Bill Data ", updateBillData);
    //   let cp=[...updateBillData?.counterSalesChild]
    //   let arr=[...updateBillData?.counterSalesChild].filter((item, index, self) =>
    //   index === self.findIndex((obj) => obj.itemId !== item.itemId)
    // );
    // let obj={...updateBillData}
    //   obj.counterSalesChild=arr
    //   setPayloadCollection(cp)
    //   setbillData(obj);
  }, [billData]);
  const [CollectionTableItems, setCollectionTableItems] = useState([]);

  const payableValueCalculate = () => {
    let sum = sumItemPrice().sum;
    // console.log("payableValueCalculate sum ", sum);
    let discountPrice = (billData?.discount / 100) * sum;
    // console.log("payableValueCalculate discountPrice ", billData?.discount);

    if (billData?.discountType === "Percent") {
      // console.log(
      //   "payableValueCalculate sum - discountPrice ",
      //   sum - discountPrice,
      // );

      return sum - discountPrice;
    } else {
      // console.log(
      //   "payableValueCalculate  sum - billData?.discount ",
      //   sum - billData?.discount,
      // );

      return sum - billData?.discount;
    }
  };
  const addQuantity = (ele, index) => {
    let obj = { ...ele };
    obj.quantity++;
    let quan = obj.quantity;
    let rate = obj.rate;
    obj.amount = (rate + obj.rate * (obj.gst / 100)) * obj.quantity;
    // console.log("eleeleele = ", ele);
    // obj.amount =
    //   (item[1].price + (item[1].price * item[1].gst) / 100) *
    //   item[1].suppliedQuantity;
    let arr = [...billData.counterSalesChild];
    arr[index] = obj;
    setbillData({
      ...billData,
      counterSalesChild: arr,
    });
  };
  const getUniqueElements = (leftArray, rightArray) => {
    // Return elements from rightArray where no matching itemId exists in leftArray
    return rightArray.filter(
      (rightItem) =>
        !leftArray.some((leftItem) => leftItem.itemId === rightItem.itemId),
    );
  };

  const newDataAddedData = (left, right) => {
    let arr1 = [];
    if (Array.isArray(left) && Array.isArray(right)) {
      // Filter out duplicate objects based on itemId
      arr1 = getUniqueElements(left, right);
      // console.log("arrIndex newly added ", arr1);
    }
    return arr1;
  };
  const getUniqueElementsInLeftArray = (leftArray, rightArray) => {
    // Return elements from leftArray where no matching itemId exists in rightArray
    return leftArray.filter(
      (leftItem) =>
        !rightArray.some((rightItem) => rightItem.itemId === leftItem.itemId),
    );
  };
  const removeElementsFromLeftArray = (leftArray, tempArr) => {
    // Filter out elements from leftArray that are present in tempArr
    return leftArray.filter(
      (leftItem) =>
        !tempArr.some((tempItem) => tempItem.itemId === leftItem.itemId),
    );
  };

  const removeDeleteValFromPayload = (payloadcollection, counterSalesChild) => {
    const remved_removedEleemnt = removeElementsFromLeftArray(
      payloadcollection,
      counterSalesChild,
    );
    // console.log("arrindex removeElementsFromLeftArray", remved_removedEleemnt);
    return remved_removedEleemnt;
  };
  // const removeMatchingElements = (payloadcollectionTemp, newAdataremoveDataFn) => {
  //   // Filter out the elements in payloadcollectionTemp that are NOT in newAdataremoveDataFn
  //   const removedElements = payloadcollectionTemp.filter(payloadItem =>
  //     !newAdataremoveDataFn.some(removeItem => removeItem.itemId === payloadItem.itemId)
  //   );

  //   // Return only the elements that were not present in newAdataremoveDataFn
  //   return removedElements;
  // };
  const removeElementFromPayload = (
    payloadcollectionTemp,
    newAdataremoveDataFn,
  ) => {
    let arr = [];
    payloadcollectionTemp.forEach((ele, index) => {
      let indexFn = newAdataremoveDataFn.findIndex(
        (elet) => elet?.itemId == ele?.itemId,
      );
      if (indexFn == -1) {
        arr.push(ele);
      }
    });

    return arr;
  };

  const updateElementFromPayload = (payloadcollectionTemp, updateDataFn) => {
    let arr = [...payloadcollectionTemp];
    updateDataFn.forEach((ele, index) => {
      let indexFn = payloadcollectionTemp.findIndex(
        (elet) => elet?.itemId == ele?.itemId,
      );
      if (indexFn != -1) {
        arr[indexFn] = ele;
      }
    });

    return arr;
  };

  const updateLeftArrayWithRightArray = (leftArray, rightArray) => {
    return leftArray.map((leftItem) => {
      const matchingRightItem = rightArray.find(
        (rightItem) => rightItem.itemId === leftItem.itemId,
      );

      // If a matching itemId is found in rightArray, replace/merge the leftItem
      return matchingRightItem
        ? { ...leftItem, ...matchingRightItem }
        : leftItem;
    });
  };

  const subQuantity = (ele, index) => {
    let obj = { ...ele };
    let arr = [...billData.counterSalesChild];

    if (obj.quantity > 1) {
      obj.quantity--;
      let quan = obj.quantity;
      let rate = obj.rate;
      obj.amount = (rate + obj.rate * (obj.gst / 100)) * obj.quantity;
      arr[index] = obj;
      setbillData({
        ...billData,
        counterSalesChild: arr,
      });
    } else {
      removeItem(index);
      removeFromPayloadCollection(arr[index]);
    }
  };
  const sumItemPrice = () => {
    let sum = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    billData?.counterSalesChild?.forEach((item) => {
      sum +=
        item.amount +
        (item.amount * item.sgst) / 100 +
        (item.amount * item.igst) / 100 +
        (item.amount * item.cgst) / 100;
      cgst += (item.amount * item.cgst) / 100;
      sgst += (item.amount * item.sgst) / 100;
      igst += (item.amount * item.igst) / 100;
    });
    return {
      sum: sum,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
    };
  };
  const addAllValue = (arr) => {
    let amount = 0;
    arr.forEach((item) => {
      amount += item.rate * item.quantity;
      // console.log("calctto amount ", amount, " ", item.itemDescription);
    });
    return amount;
  };
  const calculatedPriceWitrhDiscount = (amount, divideVal) => {
    let subVal = amount / divideVal;
    let afterCalculation = 0;
    if (billData.discount) {
      afterCalculation = amount - subVal;
    } else {
      afterCalculation = amount;
    }
    return afterCalculation;
  };

  const discountD = () => {
    if (billData?.discountType === "Percent") {
      return parseFloat((billData?.discount / 100) * sumItemPrice().sum ?? 0);
    }

    if (billData?.discountType !== "Percent") {
      return parseFloat(billData?.discount ?? 0);
    }

    if (billData?.discountType !== "Percent") {
      return parseFloat(billData?.discount ?? 0);
    }

    if (billData?.discountType === "Amount" && billData?.discount === "") {
      return 0;
    }
    return 0;
  };

  const [collectionTableItemsduplicate, setCollectionTableItemsduplicate] =
    useState([]);

  //  useEffect(() => {
  //    // console.log("data== ", data);

  //    console.log("qqq", billData?.counterSalesChild);
  //    if (billData?.counterSalesChild?.length > 0) {
  //      setNextBtnDisplay(true);
  //      // setDateValuet()
  //      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
  //    }
  //    // setstartDateFormat(dayjs("2024-12-12T00:00:00"));
  //  }, [billData?.counterSalesChild]);

  useEffect(() => {
    if (CollectionTableItems && CollectionTableItems.length > 0) {
      let duplicated = CollectionTableItems.map((collection) => ({
        ...collection,
        tableItems: collection.tableItems
          ? collection.tableItems.map((item) => ({
              ...item,
              quantity: 0,
            }))
          : [],
      }));

      if (
        billData?.counterSalesChild &&
        billData.counterSalesChild.length > 0
      ) {
        duplicated = duplicated.map((collection) => ({
          ...collection,
          tableItems: collection.tableItems
            ? collection.tableItems.map((item) => {
                const matched = billData.counterSalesChild.find(
                  (billItem) => billItem.itemId === item.id,
                );
                return matched
                  ? { ...item, quantity: matched.quantity }
                  : { ...item, quantity: 0 };
              })
            : [],
        }));
      }
      setCollectionTableItemsduplicate(duplicated);
    }
  }, [CollectionTableItems, indexTableItem, billData?.counterSalesChild]);

  const addAllAmount = () => {
    let add = 0;

    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let payableAmount = 0;
    let allAmount = addAllValue(billData.counterSalesChild ?? []);
    let discountDivVal = 0;
    let divideVal = billData.discount
      ? allAmount / billData.discount
      : allAmount; //170/10=17

    if (billData.discountType == "Amount") {
      divideVal = allAmount / billData.discount;
    }
    if (billData.discountType != "Amount") {
      let per = (allAmount * billData.discount) / 100;
      divideVal = allAmount / per;
    }

    // console.log("calctto divideVal ", divideVal);

    billData?.counterSalesChild?.forEach((item) => {
      let subVal = (item.rate * item.quantity) / divideVal; //40/17
      // console.log("calctto subVal ", subVal, " ", item.itemDescription);

      let afterCalculation = 0;
      if (billData.discount) {
        afterCalculation = item.rate * item.quantity - subVal;
      } else {
        afterCalculation = item.rate * item.quantity;
      }
      // console.log(
      //   "calctto aftercalculateion amount ",
      //   subVal,
      //   " ",
      //   item.itemDescription,
      // );

      // console.log("afterCalculation ", afterCalculation);
      add += afterCalculation;
      cgst += (afterCalculation * (item.cgst ?? 1)) / 100;
      igst += (afterCalculation * (item.igst ?? 1)) / 100;
      sgst += (afterCalculation * (item.sgst ?? 1)) / 100;
    });
    // console.log("calctto final amount ", add, " ");

    return {
      sum: add,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
      payableAmount: add + cgst + sgst + igst,
    };
  };
  useEffect(() => {}, [billData]);
  const discoundedPrice = ({ allAmount, billData }) => {
    let divideVal = billData.discount
      ? allAmount / billData.discount
      : allAmount;
    if (billData.discountType == "Amount") {
      divideVal = allAmount / billData.discount;
    }
    if (billData.discountType != "Amount") {
      let per = (allAmount * billData.discount) / 100;
      divideVal = allAmount / per;
    }

    return divideVal;
  };

  // const updateBillFunction = (callback) => {
  //   const valid = validationUpdate(billData);

  //   let payload = { ...billData };

  //   // let arrpayloadCollection = [...payloadcollection];
  //     let arrpayloadCollection = [...billData.counterSalesChild];
  //   arrpayloadCollection = arrpayloadCollection.filter((ele) => ele != null);

  //   arrpayloadCollection = arrpayloadCollection.map((ele, index) => {
  //     let calcaltedPrice = calculatedPriceWitrhDiscount(
  //       ele.rate * ele.quantity,

  //       discoundedPrice({
  //         allAmount: addAllValue(billData.counterSalesChild ?? []),
  //         billData,
  //       }),
  //     );
  //     return {
  //       ...ele,
  //       // employeePayPercentage: parseFloat(ele.employeePayPercentage),
  //       employeePayPercentage:
  //         ele.employeePayPercentage !== undefined &&
  //         ele.employeePayPercentage !== null &&
  //         ele.employeePayPercentage !== ""
  //           ? parseFloat(ele.employeePayPercentage)
  //           : 0,
  //       cgstAmount: (calcaltedPrice * (ele.cgst ?? 1)) / 100,
  //       sgstAmount: (calcaltedPrice * (ele.sgst ?? 1)) / 100,

  //       igstAmount: (calcaltedPrice * (ele.igst ?? 1)) / 100,

  //       amount: calcaltedPrice,
  //     };
  //   });
  //   //     const addAllValue = (arr) => {
  //   //   let amount = 0;
  //   //   arr.forEach((item) => {
  //   //     amount += item.amount;
  //   //   });
  //   //   return amount;
  //   // };
  //   payload.counterSalesChild = arrpayloadCollection;
  //   console.log("payloadpayloadpayload ", payload);
  //   // return;
  //   if (valid.status) {
  //     updateBil(
  //       {
  //         ...payload,
  //         discount: payload?.discount ? parseFloat(payload?.discount) : 0,
  //       },
  //       UpdateBillCounterSell,
  //       Swal,
  //       navigate,
  //       routePath,
  //       (res) => {
  //         console.log("Succeeded value:", res?.data?.succeeded);

  //        const isSuccess =
  //          res?.data?.succeeded === true || res?.data?.data?.success === true;

  //        if (isSuccess) {
  //          Swal.fire({
  //            text:
  //              res?.data?.message ||
  //              res?.data?.data?.message ||
  //              "Updated successfully",
  //            icon: "success",
  //            ...swalAlertPopProps,
  //          }).then(() => {
  //            navigate(routePath.COUNTERSELL);
  //          });
  //        } else {
  //          Swal.fire({
  //            text:
  //              res?.data?.message ||
  //              res?.data?.data?.message ||
  //              "Something went wrong",
  //            icon: "error",
  //            ...swalAlertPopProps,
  //          });
  //        }
  //         callback({ ...res, payload: { ...payload } });
  //         setDisplayContinue(false);
  //         setNextBtnDisplay(false);

  //         setPayloadCollection([]);
  //         // setbillData({});
  //         setbillData({ counterSalesChild: [] });
  //       },
  //     );
  //   }
  //   // else {
  //   //   Swal.fire({
  //   //     title: valid.msg,
  //   //     text: "",
  //   //     icon: "error",

  //   //     ...swalAlertPopProps,
  //   //   });
  //   // }
  // };
  const payableAmount = addAllAmount()?.payableAmount || 0;

  useEffect(() => {
    setbillData((prev) => {
      // Only auto-update if NOT part payment
      //  if (prev?.paymentMode === "Part") return prev;

      return {
        ...prev,
        counterSalesPartPayment: [
          {
            paymentMode: prev?.paymentMode || "Cash",
            amount: payableAmount,
            details: "",
          },
        ],
      };
    });
  }, [payableAmount]);
  const updateBillFunctionPartPayment = (callback) => {
    const valid = validationUpdate(billData);
    let payload = { ...billData };
    // let arrpayloadCollection = [...payloadcollection];
    // let arrpayloadCollection = [...billData.counterSalesChild];
    let arrpayloadCollection = [...(billData.counterSalesChild ?? [])];

    arrpayloadCollection = arrpayloadCollection.filter((ele) => ele != null);
    arrpayloadCollection = arrpayloadCollection.map((ele, index) => {
      let calcaltedPrice = calculatedPriceWitrhDiscount(
        ele.amount,
        discoundedPrice({
          allAmount: addAllValue(billData.counterSalesChild ?? []),
          billData,
        }),
      );
      return {
        ...ele,
        employeePayPercentage:
          ele.employeePayPercentage !== undefined &&
          ele.employeePayPercentage !== null &&
          ele.employeePayPercentage !== ""
            ? parseFloat(ele.employeePayPercentage)
            : 0,
        // employeePayPercentage: parseFloat(ele.employeePayPercentage),
        cgstAmount: (calcaltedPrice * (ele.cgst ?? 1)) / 100,
        sgstAmount: (calcaltedPrice * (ele.sgst ?? 1)) / 100,
        igstAmount: (calcaltedPrice * (ele.igst ?? 1)) / 100,
        amount: calculatedPriceWitrhDiscount(
          ele.amount,
          discoundedPrice({
            allAmount: addAllValue(billData.counterSalesChild ?? []),
            billData,
          }),
        ),
      };
    });
    payload.counterSalesChild = arrpayloadCollection;
    // console.log("payloadpayloadpayload ", payload);
    // return;
    if (valid.status) {
      updateBillPart(
        {
          ...payload,
          customer: payload.customer ? payload.customer : "Cash bill",
          customerMobile: payload.customerMobile ?? "",
          isCounterSalesBill: payload.paymentMode === "Credit" ? false : true,
          paymentMode: payload.paymentMode ?? "Cash",

          discountType: payload.discountType ?? "Amount",
          // employeeMasterId: payload.employeeMasterId,
          // discount: parseFloat(payload.discount??0),
          settleBill: true,
          // counterSalesChild: [],
          discount: payload?.discount ? parseFloat(payload?.discount) : 0,
        },
        updateBillPartPayment,
        Swal,
        navigate,
        routePath,
        (res) => {
          if (res?.data?.succeeded) {
            Swal.fire({
              text:
                res?.message || res?.data?.message || "Updated successfully",
              icon: "success",
              ...swalAlertPopProps,
            }).then(() => {
              navigate(routePath.COUNTERSELL);
            });
          } else {
            Swal.fire({
              text:
                res?.message || res?.data?.message || "Something went wrong",
              icon: "error",
              ...swalAlertPopProps,
            });
          }
        },
      );
    }
  };
  const filterDataForUpdate = () => {
    return;
  };
  

const payments = billData?.partPayments || [];

 const selectedPaymentMode = (() => {
   if (payments.length === 1) {
     const mode = payments[0]?.paymentMode;

     if (mode === "Cash") return "Cash";
     if (mode === "UPI") return "UPI";

     return "Part";
   }

   if (payments.length > 1) {
     return "Part";
   }

   return "Cash";
  })();
  const [selectedMode, setSelectedMode] = useState(selectedPaymentMode);

  useEffect(() => {
    setSelectedMode(selectedPaymentMode);
  }, [selectedPaymentMode]);
  return (
    <Box
      sx={{
        p: 3,
        background: "#ececff",
        minHeight: "100vh",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background:
            "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
          padding: "10px",
          borderRadius: "5px",
          color: "#01008B",
          display: "flex",
          fontFamily: "'Montserrat', sans-serif",
          fontSize: "20px",
          fontWeight: 500,
          alignItems: "center",
          justifyContent: "space-between",
          mx: 1,
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <ArrowBackIcon
            onClick={() => navigate(routePath.COUNTERSELL)}
            sx={{ cursor: "pointer" }}
          />
          <Typography variant="h6">Update Bills</Typography>
        </Box>
      </Box>

      <Grid container spacing={2} p={3}>
        <Grid
          item
          xs={12}
          md={5}
          backgroundColor={"#fff"}
          p={3}
          borderRadius={2}
          mt={2}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              fullWidth
              size="small"
              label="Search"
              value={searchItemValue}
              onChange={(e) => setSeachItemValue(e.target.value)}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Box>
              <CardMedia
                component="img"
                image={QRScanImage}
                alt="QRScanImage"
                sx={{ width: 35, height: 35 }}
              />
            </Box>
          </Box>

          <MenuSideBar
            CollectionTableItems={CollectionTableItems}
            setCollectionTableItems={setCollectionTableItems}
            indexTableItem={indexTableItem}
            setIndexTableItem={setIndexTableItem}
          />

          <ItemSidebar
            CollectionTableItems={CollectionTableItems}
            indexTableItem={indexTableItem}
            billData={billData}
            setbillData={setbillData}
            collectionTableItemsduplicate={collectionTableItemsduplicate}
            setCollectionTableItemsduplicate={setCollectionTableItemsduplicate}
            searchItemValue={searchItemValue}
          />
        </Grid>

        <Grid item xs={12} md={7}>
          <Grid
            backgroundColor={"#fff"}
            p={3}
            borderRadius={2}
            height={"72vh"}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <Box>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Bill No."
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: !!billData?.billNumber }}
                    value={billData?.billNumber}
                    // defaultValue="342"
                    size="small"
                  />
                </Grid>
                <Grid item xs={4}>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={dayjs(billData?.billDate?.split("T")[0])}
                                        format="DD-MM-YYYY"
                                        slots={{ openPickerIcon: CalendarMonthIcon }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                label: "Date",
                                                InputLabelProps: { shrink: true },
                                                InputProps: {
                                                    sx: {
                                                        background: "#fff",
                                                        height: "40px",
                                                        borderRadius: 1,
                                                    },
                                                    readOnly: true,
                                                },
                                            },
                                            openPickerIcon: {
                                                sx: { color: "#000" },
                                            },
                                        }}
                                    />
                                </LocalizationProvider> */}
                  <TextField
                    fullWidth
                    label="Date"
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <CalendarMonthIcon color="black" />
                        </InputAdornment>
                      ),
                    }}
                    InputLabelProps={{ shrink: !!billData?.billDate }}
                    value={billData?.billDate?.split("T")[0]}
                    // defaultValue="342"
                    size="small"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Mobile No."
                    InputLabelProps={{ shrink: !!billData?.customerMobile }}
                    size="small"
                    value={billData?.customerMobile}
                    onChange={async (e) => {
                      let name = null;
                      if (e.target.value.length == 10) {
                        //  const calb = await customerNameByMobile({
                        //   customerMobile: e.target.value,
                        // });
                        getUserDetailByNumber(
                          {
                            customerMobile: e.target.value.replace(/\D/g, ""),
                          },
                          (res) => {
                            // console.log("  data====", res?.data?.data);
                            name = res?.data?.data;
                            setbillData((prev) => {
                              return {
                                ...prev,
                                customer: name,
                              };
                            });
                          },
                        );
                      } else {
                      }
                      setbillData((prev) => {
                        return {
                          ...prev,
                          customerMobile: e.target.value.replace(/\D/g, ""),
                        };
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Customer Name"
                    InputLabelProps={{ shrink: !!billData?.customer }}
                    size="small"
                    value={billData?.customer}
                    onChange={(e) =>
                      setbillData({
                        ...billData,
                        customer: e.target.value,
                      })
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon
                            sx={{ cursor: "pointer" }}
                            color="primary"
                            onClick={() => {
                              setCustomerFlag(true);
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              mt={2}
              sx={{
                height: "30vh",
                overflowY: "auto",
                padding: "0px 10px 0px 0px",
              }}
            >
              {billData?.counterSalesChild?.length > 0 && (
                <Table size="small">
                  <TableHead mb={2}>
                    <TableRow>
                      <Box
                        container
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderBottom: "1.5px solid #01008B",
                          p: 1,
                          mb: 1,
                        }}
                      >
                        <Grid item xs={5}>
                          Services
                        </Grid>
                        <Grid item xs={3} sx={{ textAlign: "center" }}>
                          Price
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                          Qty
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                          Amount
                        </Grid>
                        <Grid item xs={1}></Grid>
                      </Box>
                    </TableRow>
                  </TableHead>
                  <TableBody height={"100vh"}>
                    {billData?.counterSalesChild?.map((item, index) => (
                      <TableRow key={"billlinst" + index}>
                        <TableCell colSpan={5} sx={{ border: "none", p: 0 }}>
                          <Box
                            container
                            sx={{
                              backgroundColor: "#EEEEFF",
                              borderRadius: 2,
                              mb: 1,
                              p: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Grid item xs={5}>
                              <Typography color={"#01008B"} fontWeight="bold">
                                {item?.itemDescription}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "12px" }}
                              >
                                {displayPayloadcollection
                                  .filter((elet) => {
                                    // console.log("item?.id== ", elet);
                                    return elet.itemId == item?.itemId;
                                  })
                                  .map((eleTT, index) => {
                                    return (
                                      <React.Fragment key={"index" + index}>
                                        <p key={"itemele" + index}>
                                          {eleTT.employeeName}(
                                          {eleTT.employeePayPercentage}%)
                                        </p>
                                      </React.Fragment>
                                    );
                                  })}
                              </Typography>
                            </Grid>

                            <Grid item xs={3}>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#01008B",
                                }}
                              >
                                ₹ {item?.rate}/{item?.unit}
                              </Typography>
                            </Grid>

                            <Grid item xs={1} sx={{ textAlign: "right" }}>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#01008B",
                                }}
                              >
                                {item?.quantity}
                              </Typography>
                            </Grid>

                            <Grid item xs={2} sx={{ textAlign: "right" }}>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#01008B",
                                }}
                              >
                                ₹ {item.rate.toFixed(2) * item?.quantity}
                              </Typography>
                            </Grid>

                            <Grid item xs={1} sx={{ textAlign: "right" }}>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  const itemToRemove =
                                    billData?.counterSalesChild[index];

                                  // 1️⃣ Remove from billData
                                  const updatedArr =
                                    billData.counterSalesChild.filter(
                                      (_, i) => i !== index,
                                    );

                                  setbillData((prev) => ({
                                    ...prev,
                                    counterSalesChild: updatedArr,
                                  }));

                                  // 2️⃣ Remove from payloadcollection
                                  setPayloadCollection((prev) =>
                                    prev.filter(
                                      (ele) =>
                                        ele.itemId !== itemToRemove.itemId,
                                    ),
                                  );

                                  // 3️⃣ Reset sidebar quantity
                                  if (
                                    collectionTableItemsduplicate &&
                                    collectionTableItemsduplicate[
                                      indexTableItem
                                    ]?.tableItems
                                  ) {
                                    const updatedCollection = [
                                      ...collectionTableItemsduplicate,
                                    ];

                                    updatedCollection[indexTableItem] = {
                                      ...updatedCollection[indexTableItem],
                                      tableItems: updatedCollection[
                                        indexTableItem
                                      ].tableItems.map((it) =>
                                        it.id === itemToRemove?.itemId
                                          ? { ...it, quantity: 0 }
                                          : it,
                                      ),
                                    };

                                    setCollectionTableItemsduplicate(
                                      updatedCollection,
                                    );
                                  }
                                }}
                              >
                                <CardMedia
                                  component="img"
                                  image={CloseIcon}
                                  alt="CloseIcon"
                                  sx={{ width: 30, height: 30 }}
                                />
                              </IconButton>
                            </Grid>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Box>
            <Box>
              <Box mt={2}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={600}
                      >
                        Bill Amount:{" "}
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={500}
                      >
                        ₹ {TotalAmount(billData).amount}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={600}
                        onClick={() => {
                          setOpen2(true);
                        }}
                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                      >
                        Discount :
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={500}
                      >
                        ₹ {discountD()?.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={600}
                      >
                        CGST(%) :
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={500}
                      >
                        ₹ {addAllAmount().cgst}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Right column */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={600}
                      >
                        SGST(%) :
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={500}
                      >
                        ₹ {addAllAmount().sgst}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={600}
                      >
                        IGST(%) :
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={500}
                      >
                        ₹ {addAllAmount().igst}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={600}
                      >
                        Payable Amount:
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={"15px"}
                        fontWeight={600}
                      >
                        ₹ {addAllAmount().payableAmount.toFixed(2)}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Box sx={{ borderBottom: "2px solid #01008B" }}></Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  borderTop: "1px solid #01008B",
                  pt: 2,
                }}
              >
                <Grid container spacing={2}>
                  {/* {NextBtnDisplay && (
                    <> */}
                  {/* <RadioGroup
                    row
                    // value={billData?.paymentMode ?? "Cash"}
                    value={paymentMode}
                    onChange={(e) => {
                      // setbillData({
                      //   ...billData,
                      //   paymentMode: e.target.value,
                      // });
                      setPaymentMode(e.target.value);
                    }}
                    sx={{ width: "100%", justifyContent: "space-between" }}
                  > */}
                  <RadioGroup
                    row
                    value={selectedMode}
                    onChange={(e) => {
                      const mode = e.target.value;
                      const total = addAllAmount().payableAmount;
                      setSelectedMode(mode);
                      if (mode === "Cash" || mode === "UPI") {
                        setbillData((prev) => ({
                          ...prev,
                          paymentMode: mode,
                          counterSalesPartPayment: [
                            {
                              paymentMode: mode,
                              amount: total,
                              details: "",
                            },
                          ],
                        }));
                      }

                      if (mode === "Part") {
                        setbillData((prev) => ({
                          ...prev,
                          paymentMode: "Part",
                        }));
                        setPartModal(true);
                      }
                    }}
                    sx={{ width: "100%", justifyContent: "space-between" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <FormControlLabel
                        value="Cash"
                        control={<Radio sx={{ color: "#01008B" }} />}
                        // checked={!billData?.partPayments?.length > 0}
                        label={
                          <Typography
                            color={"#01008B"}
                            fontSize={"15px"}
                            fontWeight={600}
                          >
                            Cash Payment{" "}
                          </Typography>
                        }
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      {/* <FormControlLabel
                            value={"Credit"}
                            control={<Radio sx={{ color: "#01008B" }} />}
                            label={
                              <Typography
                                color={"#01008B"}
                                fontSize={"15px"}
                                fontWeight={600}
                              >
                                Credit Sale{" "}
                              </Typography>
                            }
                          /> */}
                      <FormControlLabel
                        value="UPI"
                        control={<Radio sx={{ color: "#01008B" }} />}
                        label={
                          <Typography
                            color={"#01008B"}
                            fontSize={{
                              xs: "12px",
                              sm: "13px",
                              md: "15px",
                            }}
                            fontWeight={600}
                          >
                            Online Payment{" "}
                          </Typography>
                        }
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <FormControlLabel
                        value="Part"
                        onClick={() => setPartModal(true)}
                        control={<Radio sx={{ color: "#01008B" }} />}
                        // checked={billData?.partPayments?.length > 0}
                        label={
                          <Typography
                            color={"#01008B"}
                            fontSize={{
                              xs: "12px",
                              sm: "13px",
                              md: "15px",
                            }}
                            fontWeight={600}
                          >
                            Part Payment
                          </Typography>
                        }
                      />
                    </Box>
                  </RadioGroup>
                  <Grid item xs={4}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#01008B",
                        color: "#fff",
                        fontWeight: 500,
                        fontSize: "15px",
                        textTransform: "none",
                        width: "100%",
                        height: 36,
                        boxShadow: "none",
                      }}
                      onClick={() => {
                        // updateBillFunction((res) => {
                        //   console.log("responce update", res);

                        // });
                        // if (paymentMode !== "Part Payment") {
                        //   updateBillFunction();
                        // } else {
                        updateBillFunctionPartPayment();
                        // }
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    {/* <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#01008B",
                          color: "#fff",
                          fontWeight: 500,
                          fontSize: "15px",
                          textTransform: "none",
                          width: "100%",
                          height: 36,
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "#01008B",
                          },
                        }}
                        onClick={() => { }}
                      >
                        Print
                      </Button> */}
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#01008B",
                            color: "#fff",
                            fontWeight: 500,
                            fontSize: "15px",
                            textTransform: "none",
                            width: "100%",
                            height: 36,
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor: "#01008B",
                            },
                          }}
                          onClick={() => {
                            // setKOT();
                            // addDataCallBack();
                            // setOpen2(false);
                          }}
                        >
                          Print
                        </Button>
                      )}
                      content={() => componentRef.current}
                      onBeforePrint={() => {
                        // setOpen2(false);
                        // addDataCallBack();
                        // updateBillFunction();
                        updateBillFunctionPartPayment();
                        // savePrintBill(
                        //   bill,
                        //   creditValidtionCheck,
                        //   Swal,
                        //   userDetail,
                        //   saveBill,
                        //   saveBillCbUser
                        // );
                      }}
                    ></ReactToPrint>
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#01008B",
                        color: "#fff",
                        fontWeight: 500,
                        fontSize: "15px",
                        textTransform: "none",
                        width: "100%",
                        height: 36,
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "#01008B",
                        },
                      }}
                      onClick={() => {
                        // updateBillFunction((res) => {
                        updateBillFunctionPartPayment((res) => {
                          // console.log("responce update", res);
                          if (billData?.billNumber) {
                            handleSendFile(
                              componentRefPDF,
                              billData?.billNumber,
                              (data) => {
                                // console.log(
                                //   "responce updateresponce update",
                                //   data,
                                // );

                                const whatsappLink = `https://web.whatsapp.com/send?phone=${
                                  billData?.customerMobile
                                }&text=${
                                  "Thanks for visiting PALACE THE SALON Your bill amount is Rs. " +
                                  payableValueCalculate().toFixed(2) +
                                  " Your Receipt -" +
                                  data?.data?.pdfBillPath +
                                  " - Elegant Prime"
                                }`;
                                window.open(whatsappLink, "_blank");

                                setEventHandle({
                                  add: false,
                                  billNumber: null,
                                });
                              },
                            );
                          }
                        });
                      }}
                    >
                      Share
                    </Button>
                  </Grid>
                  {/* </>
                  )} */}
                  {/* {!NextBtnDisplay && (
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#01008B",
                          color: "#fff",
                          fontWeight: 500,
                          fontSize: "15px",
                          textTransform: "none",
                          width: "100%",
                          height: 36,
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "#01008B",
                          },
                        }}
                        onClick={() => {
                          setOpen4(true);
                        }}
                      >
                        Assign Employee
                      </Button>
                    </Grid>
                  )} */}
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <DiscountModal
        open={open2}
        handleClose={handleClose2}
        bill={{
          ...billData,

          discount: billData.discount,
          discountType: billData?.discountType
            ? billData?.discountType
            : "Amount",
          amount: TotalAmount(billData).priceWithoutGst,
          // amount:billData.netAmount?billData.netAmount:billData.amount,
          paybill: payableValueCalculate().toFixed(2) ?? 0,
        }}
        setBill={(data) => {
          for (let prop in data) {
            // if (!billData.hasOwnProperty(prop)) {
            // }
          }
          setbillData((prev) => {
            let prevData = { ...prev, ...data };

            // prevData.amount = data.amount === NaN ? 0 : data.amount;
            return prevData;
          });
        }}
        setOpen={setOpen2}
      />

      <PrintBilling
        open2={open3}
        handleClose2={handleClose3}
        componentRef={componentRef}
        currentDataArr={billData?.counterSalesChild}
        tableName={tableName}
        priceWithoutGst={TotalAmount(billData).priceWithoutGst}
        // setKOT={setKOT}
        // setBill={setBill}
        setOpen2={setOpen3}
        addDataCallBack={() => {
          updateBil(
            {
              ...billData,
              discount: billData?.discount ? parseFloat(billData?.discount) : 0,
            },
            UpdateBillCounterSell,
            Swal,
            navigate,
            routePath,
          );
        }}
        payableBilUpdateBill={payableValueCalculate}
        paybill={addAllAmount().payableAmount.toFixed(2) ?? 0}
        paymentAttribute={addAllAmount()}
        userDetail={userDetail}
        discountType={billData?.discountType}
        discount={1}
        totalAmountBill={TotalAmount(billData).amount}
        discountAmount={
          (function () {
            if (billData?.discountType === "Percent") {
              return (billData?.discount / 100) * sumItemPrice().sum;
            }
            return billData?.discount;
          })()
          // billData?.discount
        }
        addtoCardProductCBUser={billData?.counterSalesChild}
      />

      <PrintBillingPdf
        open2={open3}
        customerMobile={eventHandle?.customerMobile}
        handleClose2={handleClose3}
        billNoR={eventHandle?.billNumber}
        componentRef={componentRefPDF}
        currentDataArr={billData?.counterSalesChild}
        tableName={tableName}
        bill={billData}
        priceWithoutGst={TotalAmount(billData).priceWithoutGst}
        // setKOT={setKOT}
        // setBill={setBill}
        setOpen2={setOpen3}
        addDataCallBack={() => {
          updateBil(
            {
              ...billData,
              discount: billData?.discount ? parseFloat(billData?.discount) : 0,
            },
            UpdateBillCounterSell,
            Swal,
            navigate,
            routePath,
          );
        }}
        payableBilUpdateBill={payableValueCalculate}
        // paybill={payableValueCalculate()}
        // paymentAttribute={sumItemPrice()}
        paybill={addAllAmount().payableAmount.toFixed(2) ?? 0}
        paymentAttribute={addAllAmount()}
        userDetail={userDetail}
        discountType={billData?.discountType}
        discount={1}
        totalAmountBill={TotalAmount(billData).amount}
        discountAmount={(function () {
          if (billData?.discountType === "Percent") {
            return (billData?.discount / 100) * sumItemPrice().sum;
          }
          return billData?.discount;
        })()}
        addtoCardProductCBUser={billData?.counterSalesChild}
      />

      <Pop
        open={open4}
        setOpen={setOpen4}
        data={billData?.counterSalesChild}
        arrCollectionCb={(data) => {
          setDisplayContinue(true);
          setPayloadCollection(data);
        }}
        NextDisplayCb={(data) => {
          setNextBtnDisplay(data);
        }}
        setBill={setbillData}
        eleCompairedIndex={1}
      />
      <PartPaymentModal
        open={partModal}
        handleClose={handleClosepart}
        setOpen={setPartModal}
        addAllAmount={addAllAmount}
        setBill={setbillData}
        bill={billData}
      />
      <CustomerModal
        open={CustomerFlag}
        setOpen={setCustomerFlag}
        setSelectedUser={(data) => {
          // console.log("datadatadata ", data);
          setbillData((prev) => {
            return {
              ...prev,
              customer: data.name ?? "",
              customerMobile: data.customerMobile ?? "",
            };
          });
        }}
      />
    </Box>
  );
}
